<template>
  <div>

    <Loader cover v-if="local.isProcessing"/>
    <CommonFilterForTable :parentState="state" @load-data="loadData"/>
    <ListTable/>

  </div>
</template>

<script>
  import {state, loadData} from './data';
  import LiveClassSchedule from '@/store/modules/live-class/live-class-schedule/index';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.LiveClassSchedule) state.registerModule(`LiveClassSchedule`, LiveClassSchedule);

  const {
    mapActions: mapLiveClassScheduleActions,
  } = createNamespacedHelpers(`LiveClassSchedule`);

  export default {
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      CommonFilterForTable: () => import('@/components/shared/filters/CommonFilterForTable.vue'),
      ListTable: () => import('./SubComponents/VdoLiveSetList.vue'),
    },
    data() {
      return {
        state: state,
        local: state.local,
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapLiveClassScheduleActions({
        getLiveClassSchedulesByFilterForTable: 'getLiveClassSchedulesByFilterForTable',
      }),
      async loadData() {
        let func = {getLiveClassSchedulesByFilterForTable: this.getLiveClassSchedulesByFilterForTable};
        await loadData(func);
      }
    },
  }
</script>
